import React from "react";
import s from "./Comment.module.scss";
import { useTranslation } from "react-i18next";

const Comment = ({ comment, setParent, executeScroll }) => {
  const { t } = useTranslation();
  return (
    <div className={s.comment}>
      <div className={s.comment_header}>
        <div className={s.image}>
          <img src={comment?.user?.photo} className={s.img} />
        </div>
        <div className={s.name}>{comment?.user?.full_name}</div>
      </div>
      <div
        className={s.comment_content}
        dangerouslySetInnerHTML={{
          __html: comment?.content,
        }}
      ></div>
      <div className={s.comment_footer}>
        <div className={s.date}>{comment?.created_at}</div>
        <div
          className={s.reply_btn}
          onClick={() => {
            setParent(comment.id);
            executeScroll();
          }}
        >
          <img src='/images/reply.png' className={s.icon} /> {t("reply")}
        </div>
      </div>
      {comment.replies && comment.replies.length > 0
        ? comment?.replies?.map((it) => (
            <div className={s.reply}>
              <div className={s.comment_header}>
                <div className={s.image}>
                  <img src={it?.user?.photo} className={s.img} />
                </div>
                <div className={s.name}>{it?.user?.full_name}</div>
              </div>
              <div
                className={s.reply_content}
                dangerouslySetInnerHTML={{
                  __html: it?.content,
                }}
              ></div>
              <div className={s.comment_footer}>
                <div className={s.date}>{it?.created_at}</div>
                <div
                  className={s.reply_btn}
                  onClick={() => {
                    setParent(comment.id);
                    executeScroll();
                  }}
                >
                  <img src='/images/reply.png' className={s.icon} />{" "}
                  {t("reply")}
                </div>
              </div>
            </div>
          ))
        : null}
    </div>
  );
};

export default Comment;
